"use client";

import type { IconType } from "react-icons";
import type { ClientSafeProvider } from "next-auth/react";
import { useSearchParams } from "next/navigation";
import { signIn } from "next-auth/react";
import { FaFacebook, FaGoogle, FaLinkedin } from "react-icons/fa6";
import { useTranslations } from "next-intl";
import { Button } from "@/components/ui/Button";
type SocialSigInOptions = "facebook" | "google" | "linkedin";
type SocialIconsMapped = { [option in SocialSigInOptions]: IconType };
const SocialIconMap: SocialIconsMapped = {
  facebook: FaFacebook,
  google: FaGoogle,
  linkedin: FaLinkedin
};
type SocialSignInButtonProps = {
  provider: ClientSafeProvider;
  className?: string;
};
const SocialSignInButton = ({
  provider,
  className
}: SocialSignInButtonProps) => {
  const t = useTranslations("signup_form");
  const searchParams = useSearchParams();
  const nextUrlParam = searchParams.get("next");
  const Icon = SocialIconMap[provider.id as SocialSigInOptions];
  return <Button startContent={Icon && <Icon />} className={className} color="primary" onPress={() => signIn(provider.id, {
    callbackUrl: `/phone?${nextUrlParam ? `next=${encodeURIComponent(nextUrlParam)}` : ""}`
  })} data-sentry-element="Button" data-sentry-component="SocialSignInButton" data-sentry-source-file="SocialSignInButton.tsx">
      <span>
        {t("button_label_prefix")} {provider.name}
      </span>
    </Button>;
};
export { SocialSignInButton };